import React from 'react';

import Question from '../../question/jsx/question.jsx'; 
import useStore from './store.js';
import shallow from 'zustand/shallow';
import Summary from '../../summary/jsx/summary.jsx'

const Page = () => {

    const { matrixData, currentId } = useStore(state =>({
        matrixData: state.matrixData,
        currentId: state.currentId   
    }), shallow);

    const pageType = matrixData['pages'][currentId]['page_type'];
    
    switch(pageType) {
        case 'Question':
            return <Question pageId={currentId} />
        case 'Summary':
            return <Summary pageId={currentId} />
    }
}

export default Page;